import { Region } from '@babylon/consumer-api/types'
import { SET_REGION_INFO } from './constants'

const setRegionInfo = (regionInfo: Region) => ({
  type: SET_REGION_INFO,
  payload: regionInfo,
})

export { setRegionInfo }
